import { render } from "./MenuGrid.vue?vue&type=template&id=f151edf6"
import script from "./MenuGrid.vue?vue&type=script&lang=js"
export * from "./MenuGrid.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/app.lensmark.kz/mini-app-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__